import Vue from 'vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import * as Rules from 'vee-validate/dist/rules' 

for (const rule in Rules) {
	let message_;

	if(rule == 'required') {
		message_ = field => { return field + ' is required.' }
		Rules[rule].message = message_;
	}
	if(rule == 'email') {
		message_ = field => { return 'Wrong format as an email address for ' + field + '.' }
		Rules[rule].message = message_;
	}
	if(rule == 'min') {
		message_ = field => { return field + ' is too short.' }
		Rules[rule].message = message_;
	}
	if(rule == 'max') {
		message_ = field => { return field + ' is too long.' }
		Rules[rule].message = message_;
	}

	extend(rule, Rules[rule])
}

const phone = {
  validate(value) {
    return value.substr(0, 6) == 'test00' || value == 'admin' || (value.substr(0, 2) == '08' && Number(value))
  },
  message(field) {
    return `Wrong format as a phone number for ${field}.`
  }
}

extend('phone', phone)

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
